module.exports = __webpack_public_path__ + "static/img/stay-option-icon-bathrobe.cd92a3a4.svg";